import { STATUS_IDS } from '../../../libs/stopStatus';

// A stop the driver only started (van temp, scan) stays selectable; one they
// finished, or that is already unreachable, does not.
const BLOCKED_STATUSES = new Set([
  STATUS_IDS.COMPLETED,
  STATUS_IDS.UNREACHABLE_INCOMPLETE,
  STATUS_IDS.UNREACHABLE_COMPLETE,
  STATUS_IDS.CLEAROUT_COMPLETE,
  STATUS_IDS.CLEAROUT_DECOMMISSION_COMPLETE,
]);

export function isUnreachableStatus(status) {
  return (
    status === STATUS_IDS.UNREACHABLE_INCOMPLETE ||
    status === STATUS_IDS.UNREACHABLE_COMPLETE
  );
}

export function isDispatchSelectable(stop) {
  const status = stop && stop.derivedStatus && stop.derivedStatus.status;
  return !BLOCKED_STATUSES.has(status);
}
